<template>
  <div class="p-6">
    <h3 class="text-[18px] font-bold text-grey-light-900">Cancellation Review</h3>
    <p class="text-[14px] text-grey-light-600 mt-1">Send cancellation request for this order</p>

    <hr class="my-4" />

    <OrderDetails :name="order?.name ?? ''" :reference="order?.reference ?? ''" :reason="selectedReason" />

    <hr class="my-4" />

    <RefundSummary
      :refund-before-deductions="refundBeforeDeductions"
      :cancellation-fee="cancellationFee"
      :refund-after-deductions="refundAfterDeductions"
    />

    <hr class="my-4" />

    <p v-if="depositMessage" class="text-[14px] text-grey-light-600">{{ depositMessage }}</p>

    <hr class="my-4" v-if="depositMessage" />

    <div class="flex gap-3">
      <Button variant="outline" class="flex-1" @click="$emit('close')">Cancel</Button>
      <Button class="flex-1 bg-teal-600 hover:bg-teal-700" @click="$emit('next')">Next</Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import OrderDetails from '@/components/shopper/lay-by/cancellation-request/OrderDetails.vue';
import RefundSummary from '@/components/shopper/lay-by/cancellation-request/RefundSummary.vue';
import { Button } from '@/components/ui/button';
import type { ModelOrderResponse } from '@layup/api-sdk';

defineProps<{
  order?: ModelOrderResponse;
  selectedReason: string;
  refundBeforeDeductions: number;
  cancellationFee: number;
  refundAfterDeductions: number;
  depositMessage: string;
}>();

defineEmits<{ next: []; close: [] }>();
</script>
